// extracted by mini-css-extract-plugin
export var divider = "_sp-0";
export var systemMessage = "_sp-1";